import { Content, useAvailableUntilLicense } from '@vodafoneis/sjonvarpskjarni-js-lib';
import moment from 'moment';
import { AVAILABLE_UNTIL_DAYS } from '../config/constants';

export const useAvailableUntil = (content: Content): string | null => {
	const availableUntilLicense = useAvailableUntilLicense(content, AVAILABLE_UNTIL_DAYS);

	return availableUntilLicense ? moment(availableUntilLicense.validTo).format('D. MMMM') : null;
};
